export default __webpack_public_path__ + "static/media/add-comment-reply.89a187f1.svg";